import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlertsAddLocation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M32.5 15V22.5H40V27.5H32.5V35H27.5V27.5H20V22.5H27.5V15H32.5ZM45 25.5C45 16.425 38.375 10 30 10C21.625 10 15 16.425 15 25.5C15 31.35 19.875 39.1 30 48.35C40.125 39.1 45 31.35 45 25.5ZM30 5C40.5 5 50 13.05 50 25.5C50 33.8 43.325 43.625 30 55C16.675 43.625 10 33.8 10 25.5C10 13.05 19.5 5 30 5Z",
		fill: "#FBC02D"
	})
});
export default SvgAlertsAddLocation;
